import { Component } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Location} from "@angular/common";
import {ApiServiceService} from "../../../../Services/api-service.service";
import {AuthService} from "../../../../Services/auth.service";
import * as moment from "moment";
import alertify from "alertifyjs";

@Component({
  selector: 'app-payment-check-status',
  templateUrl: './payment-check-status.component.html',
  styleUrls: ['./payment-check-status.component.css']
})
export class PaymentCheckStatusComponent {
  isEmpty: boolean = false;
  page: number = 0;
  num: number = 1;
  currentPage: number = 1;
  details: any;
  isLoading:Boolean= false;
  isSearching: any;
  count: number = 0;
  pageSize: number = 5;
  searchForm: any = FormGroup;
  showSearch: boolean = false;
  countDetails: any;
  searchInstruction: boolean;
  showFilters = false;
  minDate: any;
  paymentDetails:any[] = [];
  remittaDetails: any;



  constructor(
      private fb: FormBuilder,
      private apiService: ApiServiceService,
      private authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.resetForm();
  }

  resetForm() {
    this.searchForm = this.fb.group({
      paymentRef: ["", [Validators.required]],
      scheme: ["", [Validators.required]],
      searchBy: [""],
      startDate: [""],
      endDate: [""]
    });

    this.setupConditionalValidation();
    this.setupConditionalValidation2();
  }

  setupConditionalValidation() {
    this.searchForm.get('scheme')?.valueChanges.subscribe((selectedScheme) => {
      const searchByControl = this.searchForm.get('searchBy');
      if (selectedScheme === 'Anigr' || selectedScheme === 'IVAS' || selectedScheme === 'Pos') {
        searchByControl?.setValidators([Validators.required]);
      } else {
        searchByControl?.clearValidators();
      }
      searchByControl?.updateValueAndValidity();
    });
  }

  setupConditionalValidation2() {
    this.searchForm.get('searchBy')?.valueChanges.subscribe((selectedScheme) => {
      const startDateControl = this.searchForm.get('startDate');
      const endDateControl = this.searchForm.get('endDate');
      if (selectedScheme === 'customer_number') {
        startDateControl?.setValidators([Validators.required]);
        endDateControl?.setValidators([Validators.required]);
      } else {
        startDateControl?.clearValidators();
        endDateControl?.clearValidators();
      }
      startDateControl?.updateValueAndValidity();
      endDateControl?.updateValueAndValidity();
    });
  }


  search() {
    this.isLoading = true;
    this.isSearching = true;

    const dto = {
      searchValue:this.searchForm.value.paymentRef,
      orderId:this.searchForm.value.paymentRef,
      startDate: this.searchForm.value.startDate,
      endDate: this.searchForm.value.endDate,
      scheme: this.searchForm.value.scheme,
      searchBy: this.searchForm.value.searchBy
    }
    const url = `/assessments/interswitch/interswitch_acknowledge/check`
    this.apiService.post(url, dto).subscribe(res=>{
      this.paymentDetails = res;
      this.remittaDetails = res;
        this.isLoading = false;
        this.isSearching = false;
      alertify.set("notifier", "position", "top-center");
      alertify.success("Search completed successfully");
    }, error => {
      this.isLoading = false;
      alertify.set("notifier", "position", "top-center");
      alertify.error("Unable to retrieve the payments");
    })
  }

  hasAccess(permissions:string[]){
    return this.authService.hasAnyPermission(permissions)
  }
}
